// Define screen width breakpoint
export const DESKTOP_BREAKPOINT_MIN = 1440
export const DESKTOP_BREAKPOINT_MAX = 1920 // Exclusive upper bound

// Define how many items are visible at certain screen widths
export const LIMITED_MENU_COUNT = 5
